const assetPageStyle = (theme) => ({
  paddingTop5: {
    paddingTop: "5px",
  },
  paddingBottom5: {
    paddingBottom: "5px",
  },
  padding10: {
    padding: "10px 0",
  },
  padding20: {
    padding: "0 20px",
  },
  card: {
    margin: "5px 0px 5px 0px",
  },
  productSection: (props) => {
    return { ...theme.arrowItem, height: props.matchesMD ? theme.arrowItem.height : "auto" };
  },
  arrowTipItem: (props) => {
    return {
      ...theme.arrowTipItem,
      height: "100%",
      "&:after": {
        ...theme.arrowTipItem["&:after"],
        borderTop: props.arrowItemHeight / 2 + "px solid transparent",
        borderBottom: props.arrowItemHeight / 2 + "px solid transparent",
      },
    };
  },
  scheduleType: {
    ...theme.ellipsisLabel,
    fontFamily: "SparBd",
    fontSize: "20px",
  },
  total: {
    fontFamily: "SparBd",
    fontSize: "18px",
  },
  productName: {
    ...theme.ellipsisLabel,
    fontSize: "15px",
  },
  quoteInfo: {
    "& $buttonStyle": {
      "& span": {
        flexDirection: "column",
        fontSize: "10px",
        textTransform: "lowercase",
      },
    },
  },
  assetSection: {
    padding: "0 10px 0 20px",
    borderRight: "1px solid #e5e5e5",
  },
  priceSection: {
    padding: "10px 25px 10px 20px",
    position: "relative",
  },
  qttySection: {
    padding: "10px 20px 10px 0",
    borderRight: "1px solid #e5e5e5",
  },
  buttonStyle: {},
  iconStyle: {
    height: "30px",
    width: "30px",
  },
  reducedFont: {
    fontSize: "11px",
  },
  minFont: {
    fontSize: "9px",
  },
  filterStyle: {
    padding: "0 15px",
  },
  dashedBox: {
    marginTop: 10,
    marginBottom: 10,
    padding: 20,
    borderStyle: "dashed",
    borderRadius: 1,
    borderWidth: 3,
    borderColor: "#d3d3d3",
    textAlign: "center",
  },
  paper: {
    width: "30%",
  },
  marginTop10: {
    marginTop: "10px",
  },
  textFieldLabel: {
    whiteSpace: "noWrap",
  },
  ellipsisLabel: {
    ...theme.ellipsisLabel,
  },
  moreActionsBtn: {
    position: "absolute",
    top: 0,
    right: 0,
  },
});

export default assetPageStyle;
